import * as React from "react"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {createBatchFormData} from "../../@signals"


export default function CustomerAutocomplete({clientType, value, onChange, ...props}) {
	// raw2raw restricts the list to retailer customers via the batch-admin endpoint;
	// other batch types use the shared brands endpoint (full customer list).
	// clientType goes through `filters` (not the URL) so the seeker serialises it as a clean
	// query param — embedding it in urlAjax would collide with the seeker's own `?` and break.
	const urlAjax = clientType
		? `${BACKEND_APIS.BATCH_ADMIN}/customers`
		: `${BACKEND_APIS.BRANDS}/crud/customer`
	const filters = clientType ? {clientType} : {}

	// Controlled mode for screens that are not the Create Batch drawer. Uncontrolled, this
	// component WRITES createBatchFormData.customerID, so mounting it anywhere else edits
	// the pending batch draft — a second screen would silently repoint a half-filled Create
	// Batch form at another customer while keeping the brands picked for the first one.
	// No caller today; kept so the next one does not have to rediscover that.
	const controlled = value !== undefined

	return <AutocompleteAjaxSeeker
		urlAjax={urlAjax}
		filters={filters}
		label="Customer"
		placeholder="Select Customer..."
		value={controlled ? value : createBatchFormData.value.customerID}
		onChange={e => {
			if (controlled) onChange(e.target.value)
			else createBatchFormData.value = {...createBatchFormData.value, customerID: e.target.value}
		}}
		required
		{...props}
	/>
}
